var exports = {
  "Cr": "ssoWarningBanner__on9zHv",
  "Qd": "alertIcon__SRI-0a",
};

module.exports = exports;
